import React from 'react'
import { StyleMessageHeader } from '../style'
import { useDispatch, useSelector } from 'react-redux'
import { StyleAvatar, StyleName } from '@commons/chats/style'
import { Actions } from '@store/index'
import BackButton from '@components/backButton'
import useIsMobile from '@hooks/useIsMobile'

const MessageHeader = () => {
  const isMobile = useIsMobile()
  const selectedChat = useSelector((state: any) => state.selectedChat)
  const dispatch = useDispatch()
  return (
    <StyleMessageHeader>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <BackButton
          path="/admin/customer-support"
          onClick={() => {
            dispatch(Actions.reset('selectedChat'))
          }}
        />
        <StyleAvatar src={selectedChat.avatar} />
        <div>
          <p style={{ fontSize: isMobile ? '12px' : '18px', color: '#1E1E1E' }}>
            {selectedChat.name}
          </p>
          <p
            style={{
              color: '#6B7280',
              fontWeight: 300,
              fontSize: isMobile && '10px',
            }}
          >
            online
          </p>
        </div>
      </div>
    </StyleMessageHeader>
  )
}

export default MessageHeader
